'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _HowItWorks = require('./HowItWorks.css');

var _HowItWorks2 = _interopRequireDefault(_HowItWorks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HowItWorks = (_dec = (0, _reactCssModules2.default)(_HowItWorks2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(HowItWorks, _Component);

  function HowItWorks(props) {
    (0, _classCallCheck3.default)(this, HowItWorks);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HowItWorks.__proto__ || (0, _getPrototypeOf2.default)(HowItWorks)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(HowItWorks, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = 'How it works';
      var description = 'Gender Equality Funds tracks thousands of mutual\n      funds commonly found in retirement plans.';
      var url = _config2.default.domain + _config2.default.routes.howitworks;

      var bannerImage = 'green';
      var bannerHeadline = 'How it works';
      var bannerSubtitle = 'Getting started with Gender Equality Funds';

      // IMAGES
      var sriIcon = require('../../../static/images/sri.png');
      var ussifIcon = require('../../../static/images/ussif-logo.png');
      var equileapLogo = require('../../../static/images/equileap-logo.png');
      // const equileapStamp = require('../../../static/images/equileap-stamp.png')
      var iyvLogo = require('../../../static/images/iyv-logo-project-of-2021.jpg');
      var subscoreAIcon = require('../../../static/images/GEF-icons-gender-balance-peer-rank.svg');
      var subscoreBIcon = require('../../../static/images/GEF-icons-gender-equality-peer-rank.svg');
      var subscoreCIcon = require('../../../static/images/GEF-icons-gender-equality-policies-rank.svg');
      var subscoreDIcon = require('../../../static/images/GEF-icons-gender-equality-policies-score.svg');
      var gefScoreExample = require('../../../static/images/gef-score-example.png');
      var gefRankingExample = require('../../../static/images/gef-ranking-example.png');
      var gefSubScoreExample = require('../../../static/images/gef-sub-score-example.png');
      var gefSubRankingExample = require('../../../static/images/gef-sub-ranking-example.png');
      var gefChartBExample = require('../../../static/images/example_gef_chartB.png');
      var gefChartAExample = require('../../../static/images/example_gef_chartA.png');
      var gefIyvReportCardExample = require('../../../static/images/example-iyv-report-card.png');

      // CONFIG FOR CATEGORY LISTING
      var cats = {
        'Allocation Funds': ['Allocation--15% to 30% Equity', 'Allocation--30% to 50% Equity', 'Allocation--50% to 70% Equity', 'Allocation--70% to 85% Equity', 'Allocation--85%+ Equity', 'Convertibles', 'Tactical Allocation', 'Target Date 2010', 'Target-Date 2015', 'Target-Date 2020', 'Target-Date 2025', 'Target-Date 2030', 'Target-Date 2035', 'Target-Date 2040', 'Target-Date 2045', 'Target-Date 2050', 'Target-Date 2055', 'Target-Date 2060+', 'Target-Date Retirement', 'World Allocation'],
        // 'Alternative Funds' : [
        //   'Bear Market',
        //   'Long-Short Credit',
        //   'Long-Short Equity',
        //   'Managed Futures',
        //   'Market Neutral',
        //   'Multialternative',
        //   'Multicurrency',
        //   'Options-based',
        //   'Trading--Leveraged Equity'
        // ],
        'International Equity Funds': ['China Region', 'Diversified Emerging Mkts', 'Diversified Pacific/Asia', 'Europe Stock', 'Foreign Large Blend', 'Foreign Large Growth', 'Foreign Large Value', 'Foreign Small/Mid Blend', 'Foreign Small/Mid Growth', 'Foreign Small/Mid Value', 'India Equity', 'Japan Stock', 'Latin America Stock', 'Miscellaneous Region', 'Pacific/Asia ex-Japan Stk', 'World Large Stock', 'World Small/Mid Stock'],
        'Sector Equity Funds': ['Commodities Broad Basket*', 'Commodities Precious Metals*', 'Communications', 'Consumer Cyclical', 'Consumer Defensive', 'Energy Limited Partnership', 'Equity Energy', 'Equity Precious Metals', 'Financial', 'Global Real Estate', 'Health', 'Industrials', 'Infrastructure', 'Miscellaneous Sector', 'Natural Resources', 'Real Estate', 'Technology', 'Utilities'],
        'U.S. Equity Funds': ['Large Blend', 'Large Growth', 'Large Value', 'Mid-Cap Blend', 'Mid-Cap Growth', 'Mid-Cap Value', 'Small Blend', 'Small Growth', 'Small Value']
      };
      var keys = (0, _keys2.default)(cats).sort();

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          'div',
          { styleName: 'image-banner' },
          _react2.default.createElement(
            'div',
            { styleName: 'image-banner-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'image-banner-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'image-banner-' + bannerImage },
                _react2.default.createElement(
                  'div',
                  { styleName: 'image-banner-headline' },
                  bannerHeadline
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'image-banner-subtitle' },
                  bannerSubtitle
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(
            'div',
            { styleName: 'container' },
            _react2.default.createElement(
              'div',
              { styleName: 'container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'lede' },
                'The ',
                _react2.default.createElement(
                  'strong',
                  null,
                  'Gender Equality Funds'
                ),
                ' database covers thousands of the most commonly-held U.S. mutual funds, the type of investments most common in retirement plans like employer-offered 401(k)s.'
              ),
              _react2.default.createElement(_components.Changelog, null)
            )
          )
        ),
        _react2.default.createElement(_components.Works, null),
        _react2.default.createElement(
          'div',
          { styleName: 'x-fund-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'x-fund-container-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-fund-info-photo' },
              _react2.default.createElement('div', { styleName: 'x-fund-photo', title: '401k retirement plans' }),
              _react2.default.createElement(
                'div',
                { styleName: 'x-fund-info' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-fund-info-title' },
                  'Mutual funds'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Mutual funds are collections of stocks bundled together, often hundreds or thousands of companies. They are some of the most popular investment products for retirement plans \u2013 owning so many company stocks at once helps diversify investment risk. But it is difficult to find out and track exactly what companies are inside the funds you\'re invested in. That\u2019s where we come in. We examine every holding in thousands of funds, in order to calculate gender equality scores, rankings, and grades.'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'x-sri-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'x-sri-container-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-sri-info-photo' },
              _react2.default.createElement('div', {
                styleName: 'x-sri-photo',
                title: '401k retirement plans'
              }),
              _react2.default.createElement(
                'div',
                { styleName: 'x-sri-info' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-sri-info-title' },
                  'Sustainable investing'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Some funds actively choose to invest sustainably, by considering gender equality issues or other environmental and social issues when choosing companies to invest in. If you\'re thinking about gender lens investing, sustainable funds can be a good place to start, because they often deliberately seek out companies that have strong diversity and equal opportunity policies. We feature nearly over a hundred sustainably-mandated funds in our database.'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'x-returns-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'x-returns-container-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-returns-info-photo' },
              _react2.default.createElement('div', {
                styleName: 'x-returns-photo',
                title: '401k retirement plans'
              }),
              _react2.default.createElement(
                'div',
                { styleName: 'x-returns-info' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-returns-info-title' },
                  'Sustainable investing can offer competitive returns'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'While people may become interested in gender lens investing and sustainable investing because of personal values and goals, that doesn\'t mean they\'re not looking for a competitive financial return on their investments. Fortunately, the evidence is clear: sustainable and responsible investors do not have to sacrifice returns to align investments with their values, according to ',
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.links.equileapResearch,
                      title: 'Research Papers | Equileap',
                      xstrong: true
                    },
                    'Equileap'
                  ),
                  ' and ',
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.links.ussifperf,
                      title: 'Performance and SRI | The Forum for Sustainable ' + 'and Responsible Investment',
                      xstrong: true
                    },
                    'the Forum for Sustainable and Responsible Investment'
                  ),
                  '.'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'how-it-works' },
          _react2.default.createElement(
            'div',
            { styleName: 'how-it-works-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'title' },
              'How we score mutual funds'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'lede' },
              'To power Gender Equality Funds, we combine two detailed data sources: ',
              _react2.default.createElement(
                'strong',
                null,
                'company gender equality data'
              ),
              ' from Equileap, and ',
              _react2.default.createElement(
                'strong',
                null,
                'mutual fund holdings data'
              ),
              ' from Morningstar.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'Equileap'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.equileap,
                    xstrong: true,
                    title: 'Equileap'
                  },
                  'Equileap'
                ),
                ' is a social venture that aims to accelerate progress towards gender equality in the workplace as a vital lever in reducing poverty and inequality. Equileap tackles its mission by collecting and checking data, carrying out research, and ranking and rating companies on their gender equality performance. It supports investors to deploy their capital with a gender lens, companies to improve their performance, and policy makers to bring in effective frameworks to increase gender equality at work.'
              ),
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.links.equileap, title: 'Equileap' },
                _react2.default.createElement('img', {
                  styleName: 'logo-equileap',
                  src: equileapLogo,
                  alt: 'Equileap'
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'Equileap Gender Equality Scorecard'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Gender Equality Funds'
                ),
                ' is powered by the ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.equileapResearch,
                    title: 'Equileap reports - Equileap',
                    xstrong: true
                  },
                  'Equileap Gender Equality Scorecard'
                ),
                ', inspired by the UN\u2019s Women Empowerment Principles. The Equileap Gender Equality Scorecard scores companies based on 19 criteria, including gender balance across the workforce, the gender pay gap, paid parental leave, and anti-sexual harassment policies.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Equileap researches nearly 3,500 companies, gathering publicly available information provided by the companies themselves, including in their annual reports, sustainability reports and/or on their websites. Each company is assigned a ',
                _react2.default.createElement(
                  'i',
                  null,
                  'gender equality score'
                ),
                ' between 0 and 100. These overall scores are based on four sub-scores:',
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      'Gender balance in leadership and workforce'
                    ),
                    ' (40 possible points)'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      'Equal compensation and work life balance'
                    ),
                    ' (30 possible points)'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      'Policies promoting gender equality'
                    ),
                    ' (20 possible points)'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      'Commitment, transparency, and accountability'
                    ),
                    ' (10 possible points)'
                  )
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'For each of the 19 gender equality criteria a question has been defined, and a data point has been identified to answer the question. Lastly, a score and weighting has been allocated to the individual question to reflect the judgement that some criteria may be more important for furthering gender equality than others. For more details, refer to the ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.equileapResearch,
                    title: 'Equileap reports - Equileap',
                    xstrong: true
                  },
                  'Equileap Gender Equality Global Report and Ranking'
                ),
                '.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'lower-lede-col-2' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'small-title' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'icon-label-wrap' },
                    _react2.default.createElement('img', {
                      src: subscoreAIcon,
                      alt: 'Gender balance in leadership and workforce',
                      styleName: 'inline-icon-sm'
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'icon-label' },
                      'Gender balance in leadership and workforce'
                    )
                  )
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '1 - Board of Directors'
                    ),
                    ' - Percentage of male and female Board of Directors as a proportion of the total number.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '2 - Executives'
                    ),
                    ' - Percentage of male and female Executives as a percentage of the total number.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '3 - Senior Management'
                    ),
                    ' - Percentage of male and female senior managers as a percentage of total.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '4 - Workforce'
                    ),
                    ' - Percentage of male and female employees as a percentage of total.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '5 - Promotion and Career Development Opportunities'
                    ),
                    ' - Ratio of each gender in Senior Management compared to ratio of each gender in the Workforce.'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'lower-lede-col-2' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'small-title' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'icon-label-wrap' },
                    _react2.default.createElement('img', {
                      src: subscoreBIcon,
                      alt: 'Equal compensation and work life balance',
                      styleName: 'inline-icon-sm'
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'icon-label' },
                      'Equal compensation and work life balance'
                    )
                  )
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '6 - Living Wage'
                    ),
                    ' - Commitment to ensure payment of a living wage to all employees, even in those countries that do not legally require a minimum wage or where minimum wage is not a living wage.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '7 - Gender Pay Gap'
                    ),
                    ' - Commitment to provide comparable wages for comparable work and to close the gender pay gap.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '8 - Parental Leave'
                    ),
                    ' - Paid leave programs (at least 2/3 paid) for child care to both primary or secondary carers globally or at least in the country of incorporation.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '9 - Flexible Work Options'
                    ),
                    ' - Option for employees to control and/or vary the start and end times of the work day and/or vary the location from which employees work.'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'lower-lede-col-2' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'small-title' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'icon-label-wrap' },
                    _react2.default.createElement('img', {
                      src: subscoreCIcon,
                      alt: 'Policies promoting gender equality',
                      styleName: 'inline-icon-sm'
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'icon-label' },
                      'Policies promoting gender equality'
                    )
                  )
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '10 - Training and Career Development'
                    ),
                    ' - Commitment to ensure equal access to training and career development to both men and women.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '11 - Recruitment Strategy'
                    ),
                    ' - Commitment to ensure non-discrimination against any type of demographic group and equal opportunities to ensure gender parity.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '12 - Freedom from Violence, Abuse and Sexual Harassment'
                    ),
                    ' - Prohibits all forms of violence in the work place, including verbal, physical and sexual harassment.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '13 - Safety at Work'
                    ),
                    ' - Commitment to the safety of employees in the workplace, in travel to and from the workplace, and on company related business, and ensure the safety of vendors in the workplace.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '14 - Human Rights'
                    ),
                    ' - Commitment to ensure the protection of the rights of all people it works with including employees\u2019 rights to participate in legal, civic and political affairs.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '15 - Social Supply Chain'
                    ),
                    ' - Commitment to reduce social risks in its supply chain such as forbid business related activities that condone, support, or otherwise participate in trafficking, including for labor or sexual exploitation.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '16 - Supplier Diversity'
                    ),
                    ' - Commitment to ensure diversity in the supply chain, including support for women owned businesses in the supply chain.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '17 - Employee Protection'
                    ),
                    ' - Systems and policies for the reporting of internal ethical compliance complaints without retaliation or retribution, including but not limited to access to confidential third-party ethics hotlines or systems for confidential written complaints.'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'lower-lede-col-2' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'small-title' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'icon-label-wrap' },
                    _react2.default.createElement('img', {
                      src: subscoreDIcon,
                      alt: 'Commitment, transparency, and accountability',
                      styleName: 'inline-icon-sm'
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'icon-label' },
                      'Commitment, transparency, and accountability'
                    )
                  )
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '18 - Commitment to Women\u2019s Empowerment'
                    ),
                    ' - Recognition and commitment to ensuring women\u2019s empowerment in the workplace.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '19 - Audit'
                    ),
                    ' - Undertaken and awarded an independent gender audit certificate by an Equileap recognized body.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'Analyzing fund holdings'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'As part of As You Sow\'s ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.aysinvest,
                    xstrong: true,
                    title: 'Invest Your Values | As You Sow'
                  },
                  'Invest Your Values program'
                ),
                ', we\u2019ve built a series of tools analyzing mutual funds on environmental and social issues like climate change, deforestation, tobacco, and weapon investments.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'To power these sites, we source financial data on mutual funds and equities from ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.morningstar,
                    xstrong: true,
                    title: 'Morningstar'
                  },
                  'Morningstar'
                ),
                '. This dataset covers global equities and thousands of U.S. open end mutual funds, as well as ETFs. It allows us to combine research about what industries companies are involved in, and what companies funds are investing in, to create fund scoring methodologies that grade funds on how exposed they are to different types of environmental and social investment risk.'
              ),
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.links.aysinvest,
                  title: 'Invest Your Values - As You Sow'
                },
                _react2.default.createElement('img', {
                  styleName: 'logo-iyv',
                  src: iyvLogo,
                  alt: 'Invest Your Values - As You Sow'
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'sidebar' },
              _react2.default.createElement(
                'div',
                { styleName: 'sidebar-title' },
                _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle', nospace: true }),
                '\xA0',
                _react2.default.createElement(
                  'em',
                  null,
                  'Measuring long holdings only'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'sidebar-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'When calculating a fund\'s exposure to a screen list, we only consider the portfolio\'s long investments, ignoring any shorts or liabilities. The formula for holding weight is ',
                  _react2.default.createElement(
                    'em',
                    null,
                    'holding market value divided by the sum of the market value for all long holdings in the portfolio.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'Using company gender equality data to score fund portfolios'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'To calculate gender equality scores for mutual funds, we start with the Equileap company scores, and cross-reference them with the holdings in each mutual fund. For each holding in a fund\u2019s portfolio that is covered by the Equileap Gender Scorecard, we average the company-level scores, weighted by the amount the fund has invested, to calculate an overall gender equality score for the fund.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'When averaging, we weight the scores by the market value of the holding. This means if a fund has more money invested in one holding compared to another, the Equileap score of the holding with more assets invested counts more towards the average.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The companies analyzed by Equileap cover nearly 90% of the total investments of the funds we scored. Not every holding is scored, but for most funds, a large percentage of their holdings have been scored by Equileap.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Each of the funds we analyzed is based in the U.S., offered as an open-end mutual fund or ETF, is at least 40% invested in direct stock holdings, and has at least 33% Equileap coverage \u2013 that is, at least 33% of the long-position holdings are stocks issued by companies that were scored by Equileap.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Currently, our analysis is focused on stock investments \u2013 we don\u2019t score bond funds, or other non-stock-based funds.'
              ),
              _react2.default.createElement('img', {
                styleName: 'chart-img',
                src: gefScoreExample,
                alt: 'Gender Equality Funds score example'
              }),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'small',
                  null,
                  _react2.default.createElement(
                    'em',
                    null,
                    'An example gender equality score for a fund. The score is calculated as a market value-weighted average of the individual company scores of the fund holdings, on Equileap\u2019s 100-point scale. The weighted average is roudned to the nearest whole number.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'Ranking fund gender equality scores'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'For a fund to earn a score of 100 out of 100 points, it would have to only invest in companies that earn the highest available score from Equileap, a 100 out of 100.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Unfortunately, currently there are zero companies that earn Equileap\u2019s highest available score score. That means earning an overall gender equality score of 100 points is unattainable for mutual funds, until companies shift.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'To give a relative sense of whether a fund is doing better or worse than other funds, in addition to the gender equality score, we also rank the fund. Each fund is ranked in three groupings:'
              ),
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    'All funds:'
                  ),
                  ' the entire universe of 4,500+ scored funds'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Groups:'
                  ),
                  ' one of four Morningstar category groups: ',
                  _react2.default.createElement(
                    'strong',
                    null,
                    'allocation funds'
                  ),
                  ', ',
                  _react2.default.createElement(
                    'strong',
                    null,
                    'international equity funds'
                  ),
                  ', ',
                  _react2.default.createElement(
                    'strong',
                    null,
                    'sector equity funds'
                  ),
                  ', or ',
                  _react2.default.createElement(
                    'strong',
                    null,
                    'U.S. equity funds'
                  ),
                  '.'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Categories:'
                  ),
                  ' one of 70+ Morningstar categories, which serve as sub-categories of the four larger groups'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'The rankings are presented as percentile rankings. If a fund earns a group ranking of 75, that can be read as: "This fund ranked better than or equal to 75% of the other funds in the same fund group." If a fund earns an overall ranking of 50, that can be read as: "This fund ranked better than or equal to 50% of all other funds in the dataset."'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Finally, an A-B-C-D-F letter grade is assigned based on which quintile the fund\u2019s ranking places it: "A grade" funds are in the top 20% of their group, and so on, with "F grade" funds in the bottom 20% of their group.'
              ),
              _react2.default.createElement('img', {
                styleName: 'chart-img',
                src: gefRankingExample,
                alt: 'Gender Equality Funds ranking example'
              }),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'small',
                  null,
                  _react2.default.createElement(
                    'em',
                    null,
                    'An example gender equality grade and percentile rank for a fund. Funds are assigned a letter grade based on where their gender equality score ranks within their assigned group. In this example, the fund\u2019s gender equality score ranked 926 out of 2,371 funds in the U.S. Equity Fund group. This figures to a percentile ranking of 61 (i.e. the fund\u2019s score is better than or equal to 61% of funds in this group). The fund earns a "B" grade for having a group percentile ranking in the 60-80 band. To see how changing the grouping affects the ranking, try switching to "All funds" for a broader universe of funds, or "Categories" for a narrower universe of funds. Only the group ranking is assigned a letter grade.'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'grade-row' },
                _react2.default.createElement(_components.Grade, { grade: 1, large: true }),
                _react2.default.createElement(_components.Grade, { grade: 2, large: true }),
                _react2.default.createElement(_components.Grade, { grade: 3, large: true }),
                _react2.default.createElement(_components.Grade, { grade: 4, large: true }),
                _react2.default.createElement(_components.Grade, { grade: 5, large: true })
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'small',
                  null,
                  _react2.default.createElement(
                    'em',
                    null,
                    'Five letter grades are available, based on which quintile the fund\'s group ranking places it: "A grade" for funds in the top 20% of their group, "B grade" for funds in the 60-80 percentile range, "C grade" for funds in the 40-60 percentile range, "D grade" for funds in the 20-40 percentile range, and "F grade" for funds in the bottom 20% of the group.'
                  )
                )
              ),
              _react2.default.createElement('img', {
                styleName: 'chart-img',
                src: gefChartAExample,
                alt: 'Gender Equality Funds gender equality ranking chart'
              }),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'small',
                  null,
                  _react2.default.createElement(
                    'em',
                    null,
                    'An example gender gender equality ranking chart for a fund. The orange marker represents this fund. The purple marker (if present) represents an assigned benchmark. Dark gray dots represent funds in the same grading group as this fund. Blue dots represent funds in the same Morningstar category as this fund. The higher a fund is marked on the Y axis, the better its gender equality score, expressed as 0-100 points. The higher a fund is marked on the X axis, the better its Gender Equality Funds group ranking, expressed as a percentile. Based on which percentile band the fund ends up in, a letter grade is assigned.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'group-table-wrap' },
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Morningstar groups and categories'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'grp-cats-wrap' },
                /* MAP CATEGORIES TO MAKE A SET OF BOXES */
                keys.map(function (el, idx) {
                  var cat = cats[el].sort();
                  return _react2.default.createElement(
                    'div',
                    {
                      key: 'grp' + idx,
                      styleName: 'grp-cats-grp'
                    },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'grp-cats-grp-lbl' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.list + '?grp=' + el,
                          xstrong: true
                        },
                        el
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'grp-cats-cat' },
                      cat.map(function (_el, _idx) {
                        return _react2.default.createElement(
                          'div',
                          {
                            key: 'ct' + _idx,
                            styleName: 'grp-cats-cat-lbl'
                          },
                          _el
                        );
                      })
                    )
                  );
                })
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'small',
                  null,
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: 'http://im.mstar.com/im/newhomepage/Morningstar_Category_Definitions_US_June_2016.pdf',
                      xstrong: true,
                      title: 'Morningstar Fund Returns'
                    },
                    'Source: Morningstar'
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    'em',
                    null,
                    _react2.default.createElement(
                      'sup',
                      null,
                      '*'
                    ),
                    'Morningstar places the Commodities categories in their own group. This grouping has too few scored funds to be used as an effective ranking universe, so for the Gender Equality Funds groups, the Commodities categories have been included in the Sector Equity Funds group.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'Sub-scores and ranks'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'We also calculate four sub-scores for each fund. For the four categories making up the Equileap Gender Equality Scorecard \u2013 gender balance in leadership and workforce; equal compensation and work life balance; policies promoting gender equality; and commitment, transparency, and accountability \u2013 we apply the same process of averaging the company scores, weighted by market value.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The gender balance in leadership and workforce score is out of 40 points; the equal compensation and work life balance score is out of 30 points; the policies promoting gender equality score is out of 20 points; and the commitment, transparency, and accountability; score is out of 10 points.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'For each sub-score, we also rank each fund in the same groupings as we do for the overall gender equality score.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'This breakdown can help show if the companies inside a fund portfolio are leading or lagging in the various areas covered by the Equileap Gender Equality Scorecard.'
              ),
              _react2.default.createElement('img', {
                styleName: 'chart-img',
                src: gefSubScoreExample,
                alt: 'Gender Equality Funds sub-category score example'
              }),
              _react2.default.createElement('img', {
                styleName: 'chart-img',
                src: gefSubRankingExample,
                alt: 'Gender Equality Funds sub-category ranking example'
              }),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'small',
                  null,
                  _react2.default.createElement(
                    'em',
                    null,
                    'An example set of scores and ranks for the four sub-scores.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'Invest Your Values report card'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'Since 2015, As You Sow\u2019s Invest Your Values free online tools have screened mutual fund holdings against a range of environmental and social issues, including climate change, gender equality, and weapon investments. You can see a fund\u2019s results across all our tools in a single convenient report card. The Invest Your Values report card displays the latest analysis, on every issue we track, for every fund in our database, making it easy for you to see which funds meet your sustainable investing needs on gender equality, climate change, and more.'
              ),
              _react2.default.createElement('img', {
                styleName: 'chart-img',
                src: gefIyvReportCardExample,
                alt: 'Invest Your Values report card example'
              }),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'small',
                  null,
                  _react2.default.createElement(
                    'em',
                    null,
                    'An example Invest Your Values report card for a fund. For various environmental and social issues, funds are assigned letter grades representing their results for that environmental or social issue. Click through to see a detailed analysis of the fund on our different Invest Your Values tools, including Fossil Free Funds, Deforestation Free Funds, Weapon Free Funds, and more.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'Top and bottom-scored holdings'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'We list the top 10 holdings in each portfolio with the best scores on the Equileap Gender Scorecard, as well as the bottom 10 holdings with the worst scores.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'These lists represent the holdings that are having the biggest effect, both positive and negative, on the fund\'s overall gender equality score.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'In the case of ties, for both lists, the holding with more assets invested is listed higher. For example, if two holdings both earned zero points on the Equileap scorecard, the holding that had more money invested by the fund would be listed higher on the list of 10 worst-scoring holdings.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'Financial returns and benchmark comparisons'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'Comparing to a benchmark is a common way of measuring a fund\u2019s performance. You can compare each fund to a benchmark suggested by Morningstar, or choose from a set of common indexes. See whether the fund had better or worse returns than the benchmark, and whether it had better or worse gender equality scores.'
              ),
              _react2.default.createElement('img', {
                styleName: 'chart-img',
                src: gefChartBExample,
                alt: 'Gender Equality Funds financial performance compared to ' + 'gender equality ranking chart'
              }),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'small',
                  null,
                  _react2.default.createElement(
                    'em',
                    null,
                    'An example financial performance chart for a fund. Each fund has its annualized returns and Gender Equality Fund grades charted. The orange marker represents this fund. The purple marker (if present) represents an assigned benchmark. Dark gray dots represent funds in the same grading group as this fund. Blue dots represent funds in the same Morningstar category as this fund. The higher a fund is marked on the Y axis, the better its returns for the specified time period. The higher a fund is marked on the X axis, the better its Gender Equality Funds group ranking.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'We track sustainably-mandated funds'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'We use Morningstar\u2019s "sustainability mandate" indicator to determine which funds to tag as socially responsible. Funds with sustainability mandates may make investment decisions based on issues like environmental responsibility, human rights, or religious views. A sustainably-mandated fund may take a proactive stance by selectively investing in, for example, environmentally-friendly companies or firms with good employee relations. They may also avoid investing in companies involved in promoting alcohol, tobacco, or firearms, or in the defense industry. Look for this symbol to find funds that are designated as having a sustainability mandate.'
              ),
              _react2.default.createElement('img', {
                styleName: 'sri',
                src: sriIcon,
                alt: 'Sustainably-mandated fund',
                'data-multiline': true,
                'data-effect': 'solid',
                'data-html': true,
                'data-for': 'sri-icon-tooltip',
                'data-place': 'bottom',
                'data-tip': _format2.default.tooltipHtml('Designated a sustainably-mandated fund by ' + 'Morningstar. Sustainably-mandated funds may ' + 'consider issues like the environment and human rights ' + 'in investment decisions.')
              }),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.ussif,
                    xstrong: true,
                    title: 'The Forum for Sustainable and Responsible Investment ' + '(US-SIF)'
                  },
                  'The Forum for Sustainable and Responsible Investment (US-SIF)'
                ),
                ' is a group advancing sustainable, responsible, and impact investing. Asset managers who are members of US-SIF often have policies to consider the diversity and equal employment opportunity policies and practices of the companies they invest in. Look for this symbol to find funds that are members of US-SIF.'
              ),
              _react2.default.createElement('img', {
                styleName: 'ussif',
                src: ussifIcon,
                alt: 'Member of US-SIF, the Forum for Sustainable and ' + 'Responsible Investment',
                'data-multiline': true,
                'data-effect': 'solid',
                'data-html': true,
                'data-for': 'ussif-icon-tooltip',
                'data-place': 'bottom',
                'data-tip': _format2.default.tooltipHtml('Member of US-SIF, the Forum for Sustainable and ' + 'Responsible Investment')
              }),
              _react2.default.createElement(_reactTooltip2.default, { id: 'sri-icon-tooltip' }),
              _react2.default.createElement(_reactTooltip2.default, { id: 'ussif-icon-tooltip' })
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'Searching for alternate investments'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.clean,
                    xstrong: true,
                    title: 'Search funds | Gender Equality Funds'
                  },
                  'Use our search page'
                ),
                ' to sort and filter our database and find the information you need. We track thousands of the most commonly-owned mutual funds in the U.S., across hundreds of fund families and dozens of investment categories.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'We\u2019ll show you at-a-glance how the fund scores, how it ranks, and whether it has a sustainability mandate. For each result, you can click through to see the full set of scores and ranks.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'Gender-lens investing action toolkit'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'When you\u2019ve looked up funds and found the data you need, what\'s next? You can learn how to make a change and move your money with our ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.toolkit,
                    xstrong: true,
                    title: 'Action toolkit | Gender Equality Funds'
                  },
                  'gender-lens investing action toolkit'
                ),
                '. Whether you\u2019re an individual investor or if your investments are in your employer-sponsored plan at work, our step-by-step toolkit can help. There\u2019s an in-depth guide to responsible investing, links to external resources, a sample letter to send to your employer 401(k) manager, and more \u2013 everything you need to make a change and get started with gender-lens investing.'
              )
            )
          )
        ),
        _react2.default.createElement(_components.GetStartedInput, null)
      );
    }
  }]);
  return HowItWorks;
}(_react.Component)) || _class);
exports.default = HowItWorks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/HowItWorks/HowItWorks.js
// module id = 1306
// module chunks = 0